import React from "react";
import { useRef,useState,useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import apiClient from "../../api/axiosClient";
import "../../styles/scoretable.css";

const ENDPOINT = "/vw-overseas-score/";

const Overseasscoretable = () => {
 const tableRef = useRef();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //  use apiClient instead of fetch
        const response = await apiClient.get(ENDPOINT);

        // axios automatically parses JSON
        setApiData(response.data.results || []); 
        setLoading(false);
      } catch (err) {
        console.error("API error:", err);
        setError("Failed to fetch data from API");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
const safeFmt = (v, digits = 2) => {
    if (v === null || v === undefined || v === "") return "-";
    // If it's already a number and finite, format it
    if (typeof v === "number" && Number.isFinite(v)) {
      return v.toFixed(digits);
    }
    // Try convert numeric strings
    const num = Number(v);
    if (!Number.isNaN(num) && Number.isFinite(num)) {
      // return fixed digits (or integer if digits === 0)
      return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
    }
    try {
      return String(v);
    } catch {
      return "-";
    }
  };

const companies = apiData.map(item => item.organisation_name);
const oil_production_percent = apiData.map(item => item.incremental_oil_percent);
const oil_production_percent_pro_rata = apiData.map(item => item.incremental_oil_percent_pro_rata);
const physical_performance_production = apiData.map(item => item.physical_performance_score);
const oil_production_2024 = apiData.map(item => item.total_oil_2024);
const oil_production_pro_rata = apiData.map(item => item.total_oil_production_score_pro_rata);
const oil_production_2023 = apiData.map(item => item.total_oil_2023);

const gas_production_percent = apiData.map(item => item.incremental_gas_percent);
const gas_production_pro_rata = apiData.map(item => item.total_gas_production_score_pro_rata);
const gas_production_2024 = apiData.map(item => item.total_gas_2024);
const gas_production_percent_pro_rata = apiData.map(item => item.incremental_gas_percent_pro_rata);
const gas_production_2023 = apiData.map(item => item.total_gas_2023);

const physical_performance_reserve = apiData.map(item => item.physical_performance_reserves_score);
const accretion_pro_rata = apiData.map(item => item.reserve_2p_oil_2024_score_pro_rata);
const reserve_accretion_percent = apiData.map(item => item.reserve_2p_oil_percent);
const reserve_accretion_percent_pro_rata = apiData.map(item => item.reserve_2p_oil_pro_rata);
const accretion_2024 = apiData.map(item => item.reserve_2p_oil_2024);
const accretion_2023 = apiData.map(item => item.reserve_2p_oil_2023);


const financial_performance = apiData.map(item => item.financial_performance_score);
const net_profit_pro_rata = apiData.map(item => item.net_profit_margin_2024_pro_rata);
const net_profit_margin_percent = apiData.map(item => item.improvement_net_profit_margin);
const net_profit_margin_percent_pro_rata = apiData.map(item => item.improvement_net_profit_margin_pro_rata);
const net_profit_2024 = apiData.map(item => item.net_profit_2024);
const net_profit_2023 = apiData.map(item => item.net_profit_2023);
const net_profit_margin_2024 = apiData.map(item => item.net_profit_margin_2024);
const net_profit_margin_2023 = apiData.map(item => item.net_profit_margin_2023);

const turnover_2024 = apiData.map(item => item.annual_turnover_2024);
const turnover_2023 = apiData.map(item => item.annual_turnover_2023);

const increase_overseas = apiData.map(item => item.increase_overseas_investment_score);
const overseas_investment_2024_pro_rata = apiData.map(item => item.overseas_investment_2024_pro_rata);
const overseas_investment_percent = apiData.map(item => item.growth_overseas_investment);
const overseas_investment_percent_pro_rata =apiData.map(item => item.growth_overseas_investment_pro_rata);
const overseas_investment_2024 = apiData.map(item => item.overseas_investment_2024);
const overseas_investment_2023 = apiData.map(item => item.overseas_investment_2023);

const improvement_esg = apiData.map(item => item.improvement_ESG_activities_score);
const specific_carbon_footprint = apiData.map(item => item.specific_carbon_footprint);
const specific_carbon_footprint_pro_rata = apiData.map(item => item.specific_carbon_footprint_pro_rata);
const carbon_emitted = apiData.map(item => item.total_carbon_2024);
const hc_production = apiData.map(item => item.total_carbon_2023);

const expenditure_pro_rata =apiData.map(item => item.community_expenditure_2024_pro_rata);
const expenditure_percent = apiData.map(item => item.growth_community_welfare_percent);
const expenditure_percent_pro_rata = apiData.map(item => item.growth_community_welfare_percent_pro_rata);
const expenditure_2024 = apiData.map(item => item.community_expenditure_2024);
const expenditure_2023 = apiData.map(item => item.community_expenditure_2023);


const reserve_accretion_percent_BCM =apiData.map(item => item.reserve_2p_gas_percent);
const reserve_accretion_percent_BCM_pro_rata =apiData.map(item => item.reserve_2p_gas_pro_rata);
const accretion_BCM_pro_rata =apiData.map(item => item.reserve_2p_gas_2024_score_pro_rata);
const accretion_2024_BCM =apiData.map(item => item.reserve_2p_gas_2024);
const accretion_2023_BCM =apiData.map(item => item.reserve_2p_gas_2023);
const reserve_replacement_ratio_BCM =apiData.map(item => item.reserve_replacement_ratio_raw);
const reserve_replacement_ratio_BCM_pro_rata =apiData.map(item => item.reserve_replacement_ratio_pro_rata);
const Total_score =apiData.map(item => item.grand_total);


const handleExport = () => {
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Overseas Scores" });
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Overseas_Scores.xlsx");
  };

  return (
    <div className="table-box">
      <button
        onClick={handleExport } className="export-btn"
        
      >
        Export to Excel
      </button>
      <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
        <thead className="bg-blue-600 text-white">
          <tr>
            <th className="border px-3 py-2 cursor-pointer">S.No.</th>
            <th className="border px-3 py-2 cursor-pointer">Evaluation Parameters</th>
            <th className="border px-3 py-2 cursor-pointer">Max Score</th>
            <th className="border px-3 py-2 cursor-pointer">Sub KPI Score</th>
            <th className="border px-3 py-2 cursor-pointer">Unit of Eval</th>
          
            {companies.map((company) => (
              <th key={company} className="border px-3 py-2 cursor-pointer">
                {company}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="bg-white">
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1</td>
            <td className="border px-3 py-2">
              <strong>Physical Performance-Production</strong>
            </td>
            <td className="border px-3 py-2">30</td>
            <td className="border px-3 py-2">30</td>
            <td className="border px-3 py-2"></td>
           
            {physical_performance_production.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.1</td>
            <td className="border px-3 py-2">
              Total oil production during the year 2024-25 (MMT)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">MMT</td>
          
            {oil_production_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
            <strong>  Total oil production during the year 2024-25 (MMT) Pro Rata </strong>
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {oil_production_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.2</td>
         <td className="border px-3 py-2" >
        Incremental oil production during the year 2024-25 (%)</td>

            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">%</td>
           
            {oil_production_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        <strong>Incremental oil production during the year 2024-25 (%) Pro Rata</strong></td>

            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {oil_production_percent_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           

          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.2.1</td>
            <td className="border px-3 py-2">
              Total oil production during the year 2024-25 (MMT)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {oil_production_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.2.2</td>
            <td className="border px-3 py-2">Total oil production during the year 2023-24 (MMT)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {oil_production_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.3</td>
            <td className="border px-3 py-2">
              Total gas production during the year 2024-25 (BCM)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">BCM</td>
          
             {gas_production_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
              <strong>Total gas production during the year 2024-25 (BCM) Pro Rata</strong>
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
             {gas_production_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.4</td>
            <td className="border px-3 py-2">Incremental gas production during the year 2024-25 (%)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">%</td>
            
            {gas_production_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Incremental gas production during the year 2024-25 (%) Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            
            {gas_production_percent_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>


          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.4.1</td>
            <td className="border px-3 py-2">
              Total gas production during the year 2024-25 (BCM)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
         
            {gas_production_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}

          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.4.2</td>
            <td className="border px-3 py-2">Total gas production during the year 2023-24 (BCM)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {gas_production_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2</td>
            <td className="border px-3 py-2"><strong>Physical Performance- Reserves Accretion</strong></td>
            <td className="border px-3 py-2">30</td>
            <td className="border px-3 py-2">30</td>
            <td className="border px-3 py-2"></td>
           
            {physical_performance_reserve.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.1</td>
            <td className="border px-3 py-2">2P oil reserve accretion in 2024-25 (MMT)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">7.5</td>
            <td className="border px-3 py-2">MMT</td>
           
                        {accretion_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>2P oil reserve accretion in 2024-25 (MMT) Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
                        {accretion_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.2</td>
            <td className="border px-3 py-2">2P oil reserve accretion growth</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">7.5</td>
            <td className="border px-3 py-2">%</td>
           
            {reserve_accretion_percent.map((s, i) => (
              <td key={i} className="border px-3 py-2">
                {s.toFixed(2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>2P oil reserve accretion growth Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {reserve_accretion_percent_pro_rata.map((s, i) => (
              <td key={i} className="border px-3 py-2">
                {s.toFixed(2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.2.1</td>
            <td className="border px-3 py-2">
              In year 2024-25 ( MMT)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {accretion_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.2.2</td>
            <td className="border px-3 py-2">In year 2023-24 ( MMT)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
         
           {accretion_2023.map((s, i) => (
              <td key={i} className="border px-3 py-2">
                {s.toFixed(2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.3</td>
            <td className="border px-3 py-2">
              2P gas reserves accretion in 2024-25 (BCM)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">BCM</td>
           
            {accretion_2024_BCM.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
              <strong>2P gas reserves accretion in 2024-25 (BCM) Pro Rata</strong>
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {accretion_BCM_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.4</td>
            <td className="border px-3 py-2">2P gas reserves accretion growth</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">%</td>
          
            {reserve_accretion_percent_BCM.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>2P gas reserves accretion growth Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {reserve_accretion_percent_BCM_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.4.1</td>
            <td className="border px-3 py-2">In year 2024-25 (BCM)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {accretion_2024_BCM.map((s, i) => (
              <td key={i} className="border px-3 py-2">
                {s.toFixed(2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.4.2</td>
            <td className="border px-3 py-2">
             In year 2023-24 (BCM)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {accretion_2023_BCM.map((s, i) => (
              <td key={i} className="border px-3 py-2">{s.toFixed(2)}</td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.5</td>
            <td className="border px-3 py-2">
              Reserve Replacement Ratio (2.1+2.3)/(1.1+1.3)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">%</td>
           
            {reserve_replacement_ratio_BCM.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
            <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.5</td>
            <td className="border px-3 py-2">
             <strong> Reserve Replacement Ratio (2.1+2.3)/(1.1+1.3) Pro Rata</strong>
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {reserve_replacement_ratio_BCM_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3</td>
            <td className="border px-3 py-2"><strong>Financial Performance</strong></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2"></td>
          
             {financial_performance.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.1</td>
            <td className="border px-3 py-2">
              Net Profit Margin in 2024-25
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">$</td>
           
            {net_profit_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
           <strong>  Net Profit Margin in 2024-25 Pro Rata</strong>
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {net_profit_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.2</td>
            <td className="border px-3 py-2">Improvement in Net Profit Margin (3.2.2 / 3.2.1)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">%</td>
           
            {net_profit_margin_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Improvement in Net Profit Margin (3.2.2 / 3.2.1) Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {net_profit_margin_percent_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.2.1</td>
            <td className="border px-3 py-2">
             Net Profit Margin in 2024-25 (Net Profit/ Turnover)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {net_profit_margin_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
             Net Profit Margin in 2023-24 (Net Profit/ Turnover)
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
          
            {net_profit_margin_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Net Profit (INR Crore)</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
                       {companies.map((v, i) => (
              <td key={i} className="border px-3 py-2"></td>
            ))}
          </tr>
                    <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">2024-25</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {net_profit_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
                    <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">2023-24</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {net_profit_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Turnover (INR Crore)</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
                       {companies.map((v, i) => (
              <td key={i} className="border px-3 py-2"></td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
              2024-25
            </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {turnover_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">2023-24</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {turnover_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4</td>
            <td className="border px-3 py-2"><strong>Increase in Overseas Investment (Actual; as per PI)</strong></td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2"></td>
           
             {increase_overseas.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.1</td>
            <td className="border px-3 py-2">Overseas investment in the Assessment Year (INR Crore)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">Number</td>
           
             {overseas_investment_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Overseas investment in the Assessment Year (INR Crore) Pro Rata</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {overseas_investment_2024_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.2</td>
            <td className="border px-3 py-2">Growth in overseas investment</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">%</td>
           
             {overseas_investment_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Growth in overseas investment Pro Rata </strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {overseas_investment_percent_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.2.1</td>
            <td className="border px-3 py-2">Overseas Investment in year 2024-25 (INR Crore)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">No.</td>
           
             {overseas_investment_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4.2.2</td>
            <td className="border px-3 py-2">Overseas Investment in year 2023-24 (INR Crore)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
             {overseas_investment_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"><strong>Improvement in ESG Activities</strong></td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2">10</td>
            <td className="border px-3 py-2"></td>
           
              {improvement_esg.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.1</td>
            <td className="border px-3 py-2">Specific Carbon Footprint (Total Carbon Emitted / Total HC Production) (Tonne/ MTOE) </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2">Number</td>
           
            {specific_carbon_footprint.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Specific Carbon Footprint (Total Carbon Emitted / Total HC Production) (Tonne/ MTOE) Pro Rata </strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {specific_carbon_footprint_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Total Carbon Emitted (Tonne)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {carbon_emitted.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">Total HC Production (MTOE)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {hc_production.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.2</td>
            <td className="border px-3 py-2">Expenditure on Community welfare</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">2.5</td>
            <td className="border px-3 py-2">Number</td>
           
            {expenditure_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Expenditure on Community welfare Pro Rata </strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {expenditure_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.3</td>
            <td className="border px-3 py-2">% Growth in community welfare </td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">2.5</td>
            <td className="border px-3 py-2">%</td>
           
            {expenditure_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>% Growth in community welfare Pro Rata </strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {expenditure_percent_pro_rata.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.3.1</td>
            <td className="border px-3 py-2">Expenditure on Community welfare 2024-25 (INR Crore)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {expenditure_2024.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.3.2</td>
            <td className="border px-3 py-2">Expenditure on Community welfare 2023-24 (INR Crore)</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {expenditure_2023.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

              <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Total</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">100.00</td>
           
            {Total_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
         
        </tbody>
      </table>
    </div>
  );
};

export default Overseasscoretable;